import { SearchResult } from '@/models/Repository'
import AgencyMarginApi from '@/api/AgencyMargin'
import AgencyMarginRequestApi from '@/api/AgencyMarginRequest'
import moment from 'moment/moment'
import 'moment/locale/ja'

const assignAgencyMarginModel = data => {
  return data.map(o => new AgencyMarginModel(o))
}
const assignRequestRecordsModel = data => {
  return data.map(o => new AgencyMarginRequestRecordModel(o))
}

export class AgencyMarginModel {
  constructor(item) {
    const {
      id,
      agencyId,
      agencyName,
      name,
      startDate,
      endDate,
      marginValue,
      isDefault,
      note,
      status,
      latestRequest,
      requests,
    } = item
    this.id = Number(id) || undefined
    this.agencyId = Number(agencyId) || undefined
    this.agencyName = agencyName || undefined
    this.name = name || undefined
    this.startDate = startDate || undefined
    this.endDate = endDate || undefined
    this.marginValue = marginValue === undefined ? 0 : marginValue
    this.isDefault = isDefault === undefined ? false : isDefault
    this.note = note || undefined
    this.status = status || undefined
    this.latestRequest =
      latestRequest && new AgencyMarginRequestRecordModel(latestRequest)
    this.requests = assignRequestRecordsModel(requests) || []
  }
  get isNew() {
    return !this.id
  }
  get hasLatestRequest() {
    return this.latestRequest.id != null
  }
  get marginPercent() {
    return this.marginValue ? this.marginValue + ' %' : ''
  }
  get dateRange() {
    if (!this.startDate || !this.endDate) return '使用期限なし'
    return this.startDate + ' - ' + this.endDate
  }
  get useDateRange() {
    if (!this.startDate || !this.endDate) return false
    return true
  }
  get isStatusActive() {
    return this.status === 'active'
  }
  get requestType() {
    if (this.id == null) return 'new'
    return this.requests.length > 1 ? 'update' : 'new'
  }
  get isRequestPassed() {
    return this.id != null
  }
  get displayData() {
    return this.isRequestPassed ? this : this.latestRequest
  }
  get canChangeRequest() {
    // すでに予算が通っていて、かつ申請ステータスが「承認待ち」以外
    return Boolean(this.isRequestPassed && this.status !== 'waiting')
  }
  static async search({
    keyword,
    agencyId,
    requestStatus = ['approved', 'rejected', 'waiting'],
    pageNo,
    pageSize,
  }) {
    // POST /agency_margin/search
    const query = {
      agencyId,
      keyword: keyword,
      requestStatuses: requestStatus,
    }
    const res = await AgencyMarginApi.search(query, pageNo, pageSize)
    const items = assignAgencyMarginModel(res.items)
    return new SearchResult({
      count: res.count,
      pageNo: res.pageNo,
      pageSize,
      items,
    })
  }
  static async fetchList(params) {
    // POST /request/agency_margin/search
    const ret = await AgencyMarginApi.fetchList(params)
    return ret
  }
  static async addRequest(params) {
    // POST /request/agency_margin
    const ret = await AgencyMarginApi.addRequest(params)
    return ret
  }
}

export class AgencyMarginRequestRecordModel {
  constructor(item) {
    const {
      id,
      name,
      marginValue,
      startDate,
      endDate,
      note,
      requestStatus,
      reason,
      requestTime,
      requestAccountId,
      requestAccountName,
    } = item
    this.id = Number(id) || undefined
    this.name = name || undefined
    this.marginValue = marginValue || undefined
    this.startDate = startDate || undefined
    this.endDate = endDate || undefined
    this.note = note || undefined
    this.requestStatus = requestStatus || undefined
    this.reason = reason || undefined
    this.requestTime = requestTime || undefined
    this.requestAccountId = requestAccountId || undefined
    this.requestAccountName = requestAccountName || undefined
  }
  get marginPercent() {
    return this.marginValue ? this.marginValue + ' %' : ''
  }
  get dateRange() {
    if (!this.startDate || !this.endDate) return '使用期限なし'
    return this.startDate + ' - ' + this.endDate
  }
  get statusDisplayName() {
    switch (this.requestStatus) {
      case 'waiting':
        return '承認待ち'
      case 'approved':
        return '承認済'
      case 'rejected':
        return '却下'
      case 'cancel':
        return 'キャンセル'
      default:
        return ''
    }
  }
  get isCancelable() {
    return this.requestStatus === 'waiting'
  }
  get isRejected() {
    return this.requestStatus === 'rejected'
  }
  get requestTimeToMinites() {
    if (!this.requestTime) return ''
    moment.locale('ja')
    let obj = moment(this.requestTime)
    return moment(obj).format('YYYY-MM-DD HH:mm')
  }
  static async deleteRequest(agencyMarginRequestId) {
    let ret = await AgencyMarginApi.deleteRequest(agencyMarginRequestId)
    return ret
  }
  static async editAgencyMargin(agencyMarginId) {
    let ret = await AgencyMarginApi.editAgencyMargin(agencyMarginId)
    return ret
  }
}

// POST /request/agency_margin 用の雛形
export class AddAgencyMarginForm {
  constructor(item = {}) {
    const {
      requestStatus,
      agencyId,
      name,
      agencyMarginId,
      startDate,
      endDate,
      marginValue,
      note,
    } = item
    this.requestStatus = requestStatus || undefined
    this.agencyId = Number(agencyId) || undefined
    this.name = name || undefined
    this.agencyMarginId = Number(agencyMarginId) || undefined
    this.startDate = startDate || undefined
    this.endDate = endDate || undefined
    this.marginValue = marginValue || undefined
    this.note = note || undefined
  }
  setStartDate(dateStr) {
    if (!dateStr) return
    moment.locale('ja')
    let obj = moment(dateStr)
    this.startTime = moment(obj).format('YYYY-MM-DD')
  }
  setEndDate(dateStr) {
    if (!dateStr) return
    moment.locale('ja')
    let obj = moment(dateStr)
    this.endTime = moment(obj).format('YYYY-MM-DD')
  }
  get useDateRange() {
    if (!this.startDate || !this.endDate) return false
    return true
  }
  async createRequest() {
    let ret = await AgencyMarginRequestApi.create(this)
    return ret
  }
}
